
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__container{box-sizing:border-box;position:relative}.splide__list{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{align-items:center;display:flex;flex-wrap:wrap;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;box-sizing:border-box;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}.splide{
  position:relative;
  background-color:var(--brand-primary-dark-blue);
}.splide__slide img{
  width:100%;
}.splide__pagination{
  display:none;
}.splide__arrow{
  background:var(--brand-primary-blue);
  border-radius:8px;
  border:0;
  width:3rem;
  height:3rem;
  padding:0;
  position:absolute;
  bottom:0;
  top:50%;
  transform:translateY(-50%);
  z-index:40;
  display:flex;
  justify-content:center;
  align-items:center;
  cursor:pointer;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, outline, outline-color;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
  text-decoration-line:none;
  outline:none;
  border:none;
}.splide__arrow:disabled{
    display:none;
  }.splide__arrow:hover{
    transform:translateY(-50%) scale(1.05);
  }.splide__arrow:focus{
    background-color:var(--brand-bright-blue-900);
    color:var(--brand-dark-blue-900);
    outline:2px solid var(--brand-dark-blue-900);
    outline-offset:2px;
  }.splide__arrow svg{
  fill:var(--brand-primary-dark-blue);
  width:1.25rem;
}.splide__arrow--next{
  right:var(--spacing-4);
}.splide__arrow--prev{
  left:var(--spacing-4);
}.splide__arrow--prev svg{
    transform:rotate(180deg);
  }.splide__slide.is-visible{
  visibility:visible;
}.sr-only{
  position:absolute !important;
  overflow:hidden;
  clip:rect(1px, 1px, 1px, 1px);
  width:1px;
  height:1px;
  word-wrap:normal;
}.slide-count{
  visibility:hidden;
}@media (min-width: 768px){
  .splide__arrow{justify-content:center}
    .splide__arrow--prev:after{
      top:1.25rem;
    }
}div[media-type='image'],
div[media-type='image'] > div,
div[media-type='video'],
div[media-type='video'] > div{
  aspect-ratio:4 / 3;
  height:100%;
}div[media-type='image'] > a{
  display:block;
  aspect-ratio:4 / 3;
}div[media-type='video']{
  background-color:var(--brand-gray-900);
}.gallery-image,
img{
  aspect-ratio:4 / 3;
  width:auto;
  height:100%;
  margin:0;
  max-width:100%;
  max-height:100%;
  object-fit:cover;
  object-position:center;
}.oembed-video,
.oembed-video outline-video-player{
  aspect-ratio:4 / 3;
  margin:0;
  height:100%;
}.oembed-video outline-video-player div{
  height:100%;
}iframe,
video{
  aspect-ratio:4 / 3;
  height:100%;
  margin:0;
  width:100%;
}.splide__slide.has-description div[media-type='image'],
  .splide__slide.has-description div[media-type='image'] > div,
  .splide__slide.has-description div[media-type='video'],
  .splide__slide.has-description div[media-type='video'] > div,
  .splide__slide.has-description iframe,
  .splide__slide.has-description video,
  .splide__slide.has-description img{
    aspect-ratio:16 / 9;
    weight:100%;
    height:auto;
  }.modal:not(.open){
  position:absolute;
  width:1px;
  height:1px;
  padding:0;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  white-space:nowrap;
  border-width:0;
}.modal.open{
  z-index:100;
  position:fixed;
  inset:0;
  background-color:rgba(0, 0, 0, 0.8);
}.modal-container{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  width:100vw;
  height:100vh;
  padding:1rem;
}.modal-content{
  display:flex;
  position:relative;
  flex-direction:column;
  flex-flow:column nowrap;
  flex-wrap:nowrap;
  align-items:stretch;
  justify-content:space-evenly;
  overflow:hidden;
  padding:var(--spacing-4);
  width:100%;
}@media (min-width: 1024px){.modal-content{
    width:50%
}
  }.modal-content .close{
    position:absolute;
    top:2px;
    right:2px;
    transition-duration:0.2s;
    z-index:9;
  }button.trigger{
  position:relative;
  width:100%;
  height:100%;
  cursor:pointer;
  padding:0;
  border:0;
  outline-offset:2px;
}button.trigger.has-description{
    height:auto;
  }button.trigger:hover .play-overlay .btn{
    transform:scale(1.05);
    background-color:var(--brand-primary-blue);
    background-color:var(--media-gallery-play-hover-bg, var(--brand-primary-blue));
  }button.trigger:focus .play-overlay .btn, button.trigger:focus-within .play-overlay .btn{
    background-color:var(--outline-button--primary-bg-color-focus--computed);
    color:var(--outline-button--primary-color-focus--computed);
    font-weight:var(--outline-button--primary-weight-focus--computed);
    outline:2px solid var(--outline-button-accent-color);
    outline-offset:2px;
  }.play-overlay{
  position:absolute;
  z-index:5;
  inset:0;
  display:flex;
  align-items:center;
  justify-content:center;
  width:100%;
  height:100%;
  cursor:pointer;
}.play-overlay.is-open{
    display:none;
  }.video-wrapper{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  overflow:hidden;
}.video-wrapper[hidden]{
    display:none;
  }.video{
  display:flex;
  justify-content:center;
  align-items:center;
  aspect-ratio:4 / 3;
}
`;